import { fetchJson } from '../utils/fetchJson';

export async function getApiKeys() {
  const data = await fetchJson('/api/api-keys');
  return { data: Array.isArray(data) ? data : (data?.keys || []) };
}

export async function createApiKey(keyData) {
  return fetchJson('/api/api-keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(keyData)
  });
}

export async function revokeApiKey(keyId) {
  return fetchJson(`/api/api-keys/${keyId}`, { method: 'DELETE' });
}
